import { z } from 'zod';

export const AssessSummaryResponseSchema = z.object({
  feedback: z.string().min(1, 'Feedback cannot be empty.'),
  score: z.number().min(0).max(100),
});

export type IAssessSummaryResponseDto = z.infer<
  typeof AssessSummaryResponseSchema
>;
